import "./requests-history.scss";
import { useEffect } from "react";
import PageTitle from "../../HOC/page-title";
import CardWrapper from "../../HOC/card/card";
import CardHeader from "../../components/card-header";
import {
  FilterOutlined,
} from "@ant-design/icons";

import {
  data,
  columns,
  dataAccountant,
  columnsAccountant,
  dataApplicant,
  columnsApplicant,
} from "../../components/data/history-data";
import CustomTable from "../../components/custom-table";

let finalData, finalColumns;
const getData = () => {
  if (localStorage["type"] == "accountant") {
    finalData = dataAccountant;
    finalColumns = columnsAccountant;
  } else if (localStorage["type"] == "applicant") {
    finalData = dataApplicant;
    finalColumns = columnsApplicant;
  } else if (localStorage["type"] == "evalutor") {
    finalData = data;
    finalColumns = columns;
  } else if (localStorage["type"] == "ceo") {
    finalData = data;
    finalColumns = columns;
  } else if (localStorage["type"] == "chairman") {
    finalData = data;
    finalColumns = columns;
  } else if (localStorage["type"] == "superadmin") {
    finalData = data;
    finalColumns = columns;
  } else {
    finalData = data;
    finalColumns = columns;
  }
};

const RequestsHistory = ({ handleChangeKey }) => {
  useEffect(() => {
    handleChangeKey(5);
    getData();
  }, []);
  return (
    <div className="requests-history-container">
      <CardWrapper>
        <CardHeader title="جميع الطلبات">
          {/* the button that will appear at the left of the card  header*/}
          <div className="filter-icon-container" handleClick={"showModal"}>
            <FilterOutlined /> ترشيح
          </div>
        </CardHeader>

        <CustomTable
          scroll={{ x: "max-content" }}
          columns={finalColumns}
          dataSource={finalData}
          sticky={true}
        />
      </CardWrapper>
    </div>
  );
};

export default PageTitle(RequestsHistory);
